module.exports = __webpack_public_path__ + "img/clovyr-logo.6c03a45.svg";